import React, { useMemo } from "react";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import { sanitizeHTML } from "../utility/sanitize";

const MarkDown = ({ content }) => {
  const processedHTML = useMemo(() => {
    try {
      if (!content) return "";
      const text = String(content).trim();
      if (!text) return "";
      return text.replace(/\n/g, "<br />");
    } catch (err) {
      console.error("Processing error in MarkDown:", err, content);
      return "";
    }
  }, [content]);

  const cleanHTML = useMemo(() => {
    try {
      return sanitizeHTML(processedHTML);
    } catch (err) {
      console.error("sanitizeHTML failed:", err, processedHTML);
      return "";
    }
  }, [processedHTML]);

  return (
    <MathJaxContext
      onError={(err) => console.error("MathJax error:", err)}
      config={{
        loader: { load: ["input/tex", "output/chtml"] },
        tex: {
          inlineMath: [
            ["$", "$"],
            ["\\(", "\\)"],
          ],
        },
      }}
    >
      <MathJax dynamic>
        <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
      </MathJax>
    </MathJaxContext>
  );
};

export default React.memo(MarkDown);
